



















import { Component, Prop, Vue } from 'vue-property-decorator'
@Component
export default class OrderInfo extends Vue {
	@Prop({
		type: Object,
		required: false,
		default: () => {
			return {}
		}
	})
	private orderData!: any
}
